/**
 * True cuando un error corresponde a un fallo de carga de un chunk JS/CSS
 * (import dinámico / preload de Vite). Estos fallos dejan la pantalla en blanco
 * porque el componente de ruta nunca monta — ocurren con red intermitente o,
 * típicamente, cuando el `index.html` cacheado por la PWA apunta a chunks que
 * ya devuelven 404 tras un deploy nuevo.
 *
 * Se usa para enrutar esos fallos a `error.vue` (ver `plugins/chunk-reload.client.ts`)
 * en vez de dejar la pantalla blanca. Regla G-245.
 *
 * Puro y sin DOM — directamente testeable.
 */
const CHUNK_SIGNATURES = [
  'failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'importing a module script failed',
  'loading chunk ',           // webpack/rollup: "Loading chunk 42 failed" — trailing
  'loading css chunk ',       // espacio evita falsos positivos con texto natural
  'unable to preload css',    // Vite: "Unable to preload CSS for ..."
  'chunkloaderror',
  // vue-router: el import del componente de ruta falló (chunk viejo tras deploy,
  // precedido por "Importing a module script failed") y el módulo llega sin default.
  "couldn't resolve component \"default\"",
]

export function isChunkLoadError(err: unknown): boolean {
  if (err == null) return false

  const name = (err as { name?: unknown })?.name
  if (typeof name === 'string' && name.toLowerCase() === 'chunkloaderror') return true

  let raw = ''
  if (typeof err === 'string') raw = err
  else if (err instanceof Error) raw = err.message
  else if (typeof err === 'object') {
    const m = (err as { message?: unknown }).message
    if (typeof m === 'string') raw = m
  }

  const msg = raw.toLowerCase()
  if (!msg) return false
  return CHUNK_SIGNATURES.some((sig) => msg.includes(sig))
}
